var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.topbar },
    [
      _c("div", { class: _vm.$style.logo, on: { click: _vm.handleToIndex } }, [
        _c("img", { attrs: { src: _vm.logo, alt: "智配管理系统" } }),
        _vm._v(" "),
        _c("h1", [_vm._v("智配管理系统")])
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$style.user }, [
        _c("span", [_vm._v(_vm._s(_vm.welcomeText) + "，")]),
        _vm._v(" "),
        _c("span", { class: _vm.$style.name }, [
          _vm._v(_vm._s(_vm.userInfo.realname))
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: "javascript:;" }, on: { click: _vm.handleLogout } },
          [_vm._v("退出")]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("|")]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: { href: "javascript:;" },
            on: {
              click: function($event) {
                _vm.dialogVisible = true
              }
            }
          },
          [_vm._v("修改密码")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$style.crm, on: { click: _vm.handleLoginCRM } },
          [
            _c("span", [_vm._v("CRM")]),
            _vm._v(" "),
            _c(
              "svg",
              {
                staticClass: "zp-icon",
                class: _vm.$style.icon,
                attrs: { "aria-hidden": "true" }
              },
              [_c("use", { attrs: { "xlink:href": "#icon-exit" } })]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("PasswdDialog", {
        model: {
          value: _vm.dialogVisible,
          callback: function($$v) {
            _vm.dialogVisible = $$v
          },
          expression: "dialogVisible"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }